import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import Flash from "../flash/Flash.jsx"
import { ThirdPartyApiNameByValue } from '../../repo/ThirdPartyApiRepo'

export default function AdminTournamentsShow({tournament, status}) {
  const [flashMessage, setFlashMessage] = useState("")

  useEffect(() => {
    if (status === "created") {
      setFlashMessage("Tournament was successfully created")
    } else if (status === "updated") {
      setFlashMessage("Tournament was successfully updated")
    }

    window.history.replaceState(null, "Admin - Tournament" , '/cocofantoelefanto/tournaments/' + tournament.id)
  }, [tournament.id, status])

  return(
    <>
      <h1>Show Tournament</h1>
      {flashMessage !== "" && (
        <Flash message={flashMessage} type="success"/>
      )}

      <div className="flex flex-col mt-4">
        <div key="tournament_name">
          <b>Nome:</b>
          <span className="ml-4">{ tournament.name }</span>
        </div>

        <div key="tournament_edition">
          <b>Edição:</b>
          <span className="ml-4">{ tournament.edition }</span>
        </div>

        <div key="tournament_starts_at">
          <b>Inicia em:</b>
          <span className="ml-4">{ tournament.starts_at }</span>
        </div>

        <div key="tournament_ends_at">
          <b>Términa em:</b>
          <span className="ml-4">{ tournament.ends_at }</span>
        </div>

        <div key="tournament_third_party_label">
          <b>API de terceiros:</b>
          <span className="ml-4">{ ThirdPartyApiNameByValue(tournament.third_party_label) }</span>
        </div>

        <div key="tournament_third_party_id">
          <b>ID de terceiros:</b>
          <span className="ml-4">{ tournament.third_party_id }</span>
        </div>

        <div key="tournament_third_party_season">
          <b>Edição de terceiros:</b>
          <span className="ml-4">{ tournament.third_party_season }</span>
        </div>

        <div key="tournament_tournament_standings_rules">
          <b>Regras (filters and replacements) para classificação:</b>
          <pre className="ml-4 border-r-4">{ JSON.stringify(tournament.tournament_standings.rules, null, 2) }</pre>
        </div>

        <div key="tournament_tournament_standings_content">
          <b>Conteúdo da Classificação:</b>
          <pre className="ml-4 border-r-4">{ JSON.stringify(tournament.tournament_standings.content, null, 2) }</pre>
        </div>

      </div>

      <div id="actions" className="w-full pt-4 mt-4 space-x-2">
        <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${tournament.id}/edit`}>Edit Tournament</Link>
        <span>|</span>
        <Link className="hover:no-underline underline" to="/cocofantoelefanto/tournaments">Back to Tournaments</Link>
        <span>|</span>
        <Link className="hover:no-underline underline" to="/cocofantoelefanto/tournaments/new">Create New Tournament</Link>
      </div>

    </>
  )
}
